import React from "react";
import { FaInstagram, FaPinterest, FaGithub, FaLinkedin } from "react-icons/fa";

export const SocialMedia = () => {
  return (
    <div id="social-media-container">
      <p className="social-title">⚡ ¡Pika Pika! ⚡</p>
      <p className="social-text">
        If you want to contact me or stay updated on this project, find me here!
        🚀
      </p>
      <div className="social-links">
        <a
          href="https://www.linkedin.com/in/bornsrss/"
          target="_blank"
          rel="noopener noreferrer"
          title="linkedIn"
        >
          <FaLinkedin className=" linkedin" />
        </a>
        <a
          href="https://www.instagram.com/bornsrss/"
          target="_blank"
          rel="noopener noreferrer"
          title="Instagram"
        >
          <FaInstagram className=" instagram" />
        </a>
        <a
          href="https://mx.pinterest.com/bornsrss/"
          target="_blank"
          rel="noopener noreferrer"
          title="Pinterest"
        >
          <FaPinterest className=" pinterest" />
        </a>
        <a
          href="https://github.com/bornsrss14/_created/"
          target="_blank"
          rel="noopener noreferrer"
          title="Github"
        >
          <FaGithub className=" github" />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
